<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { useSettingsStore } from '@/stores/SettingsStore.ts';
import { nextTick, onMounted, onUnmounted, reactive, watch } from 'vue';
import { Slider } from '@/components/ui/slider';
import { setAppOpacityAction } from '@/actions/electron/SetAppOpacityAction.ts';
import { eventEmitter } from '@/lib/eventEmitter.ts';

const settingsStore = useSettingsStore();

interface ComponentState {
    appOpacityCopy: number[];
    changesMade: boolean;
}

const state: ComponentState = reactive({
    appOpacityCopy: [100],
    changesMade: false,
});

const save = () => {
    settingsStore.appOpacity = state.appOpacityCopy[0];
    state.changesMade = false;
    eventEmitter.emit('setSettingsDialogVisibility', {
        visible: false,
    });
};

onMounted(async () => {
    state.appOpacityCopy = [settingsStore.appOpacity];
    await nextTick();
    state.changesMade = false;
});

onUnmounted(() => {
    setAppOpacityAction(settingsStore.appOpacity);
});

watch(
    () => [state.appOpacityCopy],
    () => {
        setAppOpacityAction(Number(state.appOpacityCopy[0]));
        state.changesMade = true;
    },
);
</script>

<template>
    <main class="flex-shrink flex-grow p-4 pt-1">
        <h2 class="mb-4 border-b pb-2">Application opacity</h2>
        <Slider v-model="state.appOpacityCopy" :min="15" :max="100" :step="5" class="w-1/2" />
    </main>

    <footer class="mt-4 flex flex-shrink-0 justify-end border-t p-4">
        <Button variant="success" @click="save" :disabled="!state.changesMade"
            >Save and close</Button
        >
    </footer>
</template>
